/**
 * Variant Name often comes with "Cheveux" in the string ex: "Cheveux mi-long"
 * we prefer to display only "mi-long"
 */
export const displayableVariantName = (name: string) =>
  name ? name.trim().toLowerCase().replace("cheveux", "") : "Pas de variante";
